<template>
  <div class="container">
    <nav-bar />
    <main class="main-section">
      <div class="container">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  components: {
    NavBar
  }
};
</script>

<style scoped>
main.main-section {
  padding-top: 4.5rem;
}
</style>
